var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #b7c5d3; } .cls-2 { fill: #b6d2d5; } .cls-3 { fill: #275877; } .cls-4 { fill: #06223f; } ")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18,
    cy: 23,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.37,33.8l3.79-.54c.33-.05,.63-.17,.89-.34,.46,4.54,4.29,8.08,8.95,8.08,4.97,0,9-4.03,9-9s-4.03-9-9-9c-4.14,0-7.62,2.79-8.67,6.59-.39-.37-.9-.59-1.47-.59h-3.74c.4-1.9,1.19-3.67,2.28-5.2,.83-.13,1.63-.5,2.26-1.14,.64-.63,1.01-1.43,1.14-2.26,1.69-1.2,3.67-2.04,5.8-2.4,.68,.5,1.5,.8,2.4,.8s1.72-.3,2.4-.8c2.13,.36,4.11,1.2,5.8,2.4,.13,.83,.5,1.63,1.14,2.26,.63,.64,1.43,1.01,2.26,1.14,1.2,1.69,2.04,3.67,2.4,5.8-.5,.68-.8,1.5-.8,2.4s.3,1.72,.8,2.4c-.36,2.13-1.2,4.11-2.4,5.8-.83,.13-1.63,.5-2.26,1.14-.64,.63-1.01,1.43-1.14,2.26-1.69,1.2-3.67,2.04-5.8,2.4-.68-.5-1.5-.8-2.4-.8s-1.72,.3-2.4,.8c-2.13-.36-4.11-1.2-5.8-2.4-.13-.83-.5-1.63-1.14-2.26-.63-.64-1.43-1.01-2.26-1.14-1.2-1.69-2.04-3.67-2.4-5.8,.14-.19,.26-.39,.37-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.05,32.92c.46,4.54,4.29,8.08,8.95,8.08,4.97,0,9-4.03,9-9s-4.03-9-9-9c-4.14,0-7.62,2.79-8.67,6.59l.04,.04c.39,.39,.63,.92,.63,1.51,0,.74-.37,1.4-.95,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.86,29H13.97c-2.49,0-4.84,1.15-6.35,3.13-2.01,2.63-4.23,7.22-4.57,14.8-.05,1.12,.85,2.06,1.98,2.06h.05c1.07,0,1.92-.81,2.03-1.86,.62-5.94,3.9-12.14,3.9-12.14v14h14v-12.27c0-1,.73-1.84,1.72-1.98l10.44-1.49c1.06-.15,1.84-1.05,1.84-2.12h0c0-1.18-.96-2.14-2.14-2.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47,
    cy: 8,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47,
    cy: 56,
    r: 6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeader);
export default __webpack_public_path__ + "static/media/icon-leader.b36c87223dff8e178ef90e156b1fa08f.svg";
export { ForwardRef as ReactComponent };